/* ==========================================================================
   PVJ - Mobile menu drawer

   One job, on the hamburger drawer only: the accordion. Opening a dropdown
   closes any sibling dropdown, at every level - open Shop and Workshops
   folds away; open Categories and Discover folds away. The theme's own
   <collapsible-elements> has an accordion mode behind a data-accordion
   attribute, but it is dead: the minified class calls a bare getSiblings()
   that is not defined anywhere, so the attribute throws a ReferenceError
   before the toggle runs and the menu stops opening at all. Hence doing it
   here.

   The accordion runs on a capture listener on .menu so it fires before the
   theme's own click handler on the trigger: siblings are closed first, then
   the original click opens what was clicked. Closing is done by dispatching
   a click at the sibling's trigger rather than by editing classes, so the
   theme stays the single owner of the open/close animation.

   This file also used to swap an image under the link list as dropdowns
   opened and closed. The images were removed on 2026-08-17 and that half of
   the script went with them - see snippets/pvj-mobile-nav-media.liquid.
   ========================================================================== */

(function () {
  'use strict';

  var nav = document.querySelector('.nav-hamburger');
  if (!nav) return;

  var menu = nav.querySelector('.menu');
  if (!menu) return;

  // Guard against the clicks we dispatch re-entering this same handler.
  var isClosingSiblings = false;

  menu.addEventListener(
    'click',
    function (event) {
      if (isClosingSiblings) return;

      var trigger = event.target.closest('[data-collapsible-trigger]');
      if (!trigger || !menu.contains(trigger)) return;

      var item = trigger.parentNode;
      if (!item || !item.classList) return;

      // Already open means this click is a close - nothing to fold away.
      if (item.classList.contains('is-expanded')) return;

      isClosingSiblings = true;

      Array.prototype.forEach.call(item.parentNode.children, function (sibling) {
        if (sibling === item) return;
        if (!sibling.classList || !sibling.classList.contains('is-expanded')) return;

        var siblingTrigger = sibling.querySelector('[data-collapsible-trigger]');
        if (siblingTrigger) siblingTrigger.dispatchEvent(new Event('click'));
      });

      isClosingSiblings = false;

      unlockAncestorsSoon(item);
    },
    true
  );

  /* The theme caps an opening submenu at a measured pixel max-height and
     clears it to none on a single 500ms timer per <collapsible-elements>.
     Opening a nested dropdown inside that window cancels the outer one's
     timer, leaving the parent stuck at its old height and clipping the last
     child. Re-clear any open ancestor once those timers have run. */
  function unlockAncestorsSoon(item) {
    setTimeout(function () {
      var parent = item.parentElement && item.parentElement.closest('.submenu');

      while (parent) {
        if (parent.getAttribute('aria-hidden') === 'false') parent.style.maxHeight = 'none';
        parent = parent.parentElement && parent.parentElement.closest('.submenu');
      }
    }, 550);
  }
})();
